import { Enum, EnumType } from 'ts-jenum';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { faBan, faDebug, faHeadset, faPhoneOffice, faPhoneRotary, faQuestionCircle } from '@fortawesome/pro-duotone-svg-icons';

@Enum<AcdTypeEnum>('value')
export class AcdTypeEnum extends EnumType<AcdTypeEnum>() {
   static readonly SOFTPHONE = new AcdTypeEnum('SAMwin.Softphone', faHeadset, true);

   // Controlled devices:
   static readonly SIP_CTI = new AcdTypeEnum('SIP_CTI', faPhoneOffice, true);
   static readonly CSTA = new AcdTypeEnum('Csta', faPhoneOffice, true);
   static readonly TAPI_LINE_NUMBER = new AcdTypeEnum('samwin.TAPI', faPhoneOffice, true);
   static readonly TAPI_LINE_NAME = new AcdTypeEnum('TAPI_LINE_NAME', faPhoneOffice, true);

   static readonly NON_CONTROLLED = new AcdTypeEnum('NonControlled', faPhoneRotary, false);
   static readonly NONE = new AcdTypeEnum('None', faBan, false);
   static readonly UNKNOWN = new AcdTypeEnum('unknown', faQuestionCircle, false);

   // internal devices (just for testing etc..)
   static readonly GLUE_LEANER = new AcdTypeEnum('GlueLeaner', faPhoneOffice, false);
   static readonly UNIT_TEST = new AcdTypeEnum('samwin.UnitTest', faDebug, false);

   public static getAcdTypeFromAcdLine(acdLine: string) {
      try {
         const acdType = AcdTypeEnum.valueOf(acdLine);
         return acdType;
      } catch {}
      return AcdTypeEnum.TAPI_LINE_NAME;
   }

   private constructor(public value: string, public icon: IconDefinition, public canAcceptCall: boolean) {
      super();
   }
}
